import $ from "jquery";
import moment from "moment";
const config = {
  showAnim: "clip",
  dateFormat: "mm/dd/yy",
  changeMonth: true,

  changeYear: true,
  yearRange: "1900:2100", ///'c-120:c+20'
  dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
};
export const getDatePicker = (fieldId) => {
  return $(fieldId).datepicker(config);
};

export const getStartDatePicker = (fieldId) => {
  var dt = new Date();
  return $(fieldId).datepicker({
    ...config,
    beforeShowDay: function (date) {
      if (date.getDate() === 1 && date > dt) {
        return [true, ""];
      }
      return [false, ""];
    },
  });
};
export const getRequEfftDatePicker = (fieldId,planYear) => {
  var dt = new Date();
  var mon=dt.getMonth();
  var year=dt.getFullYear();
  return $(fieldId).datepicker({
    ...config,
    beforeShowDay: function (date) {
      //moment(date).isSameOrAfter(dt, 'day')
      if(planYear>year){
        if (date.getDate() === 1 && (date.getMonth()===0 || date.getMonth()===1) && planYear === date.getFullYear().toString()) {
          return [true, ""];
        }
        return [false, ""];
      }
      else{
        let nxtFirstMonth=mon+1,nxtSecondMonth=mon+2,nxtThirdMonth=mon+3;
       // let nxtFirstMonthYear=year,nxtSecondMonthYear=year,nxtThirdMonthYear=year
        if(nxtFirstMonth>11){
          nxtFirstMonth=nxtFirstMonth-12
        //  nxtFirstMonthYear=year+1
        }
        if(nxtSecondMonth>11){
          nxtSecondMonth=nxtSecondMonth-12
         // nxtSecondMonthYear=year+1
        }
        if(nxtThirdMonth>11){
          nxtThirdMonth=nxtThirdMonth-12
         // nxtThirdMonthYear=year+1
        }
       
      if (date.getDate() === 1 && ((date.getMonth()===nxtFirstMonth && date.getFullYear()===year)||
      (date.getMonth()===nxtSecondMonth && date.getFullYear()===year)||
      (date.getMonth()===nxtThirdMonth && date.getFullYear()===year))) {
        return [true, ""];
      }
      return [false, ""];
     }
    },
  });
};
export const getStartDatePickerofMonth = (fieldId) => {
  return $(fieldId).datepicker({
    ...config,
    beforeShowDay: function (date) {
      if (date.getDate() === 1) {
        return [true, ""];
      }
      return [false, ""];
    },
  });
};

export const getMonthDatePicker = (fieldId) => {
  return $(fieldId).datepicker({
    ...config,
    dateFormat: "mm/yy",
    beforeShowDay: function (date) {
      if (
        date.getDate() ===
        getLastDayOfYearAndMonth(date.getFullYear(), date.getMonth())
      ) {
        return [true, ""];
      }
      return [false, ""];
    },
  });
};

export const getLastDatePicker = (fieldId) => {
  return $(fieldId).datepicker({
    ...config,
    beforeShowDay: function (date) {
      if (
        date.getDate() ===
        getLastDayOfYearAndMonth(date.getFullYear(), date.getMonth())
      ) {
        return [true, ""];
      }
      return [false, ""];
    },
  });
};

function getLastDayOfYearAndMonth(year, month) {
  return new Date(new Date(year, month + 1, 1) - 1).getDate();
}
